import { render, staticRenderFns } from "./PropertyTabs.vue?vue&type=template&id=40a3dd5a&scoped=true"
import script from "./PropertyTabs.vue?vue&type=script&lang=js"
export * from "./PropertyTabs.vue?vue&type=script&lang=js"
import style0 from "./PropertyTabs.vue?vue&type=style&index=0&id=40a3dd5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a3dd5a",
  null
  
)

export default component.exports